export default {
  returnPlacedOrder: (state, getters, rootState, rootGetters) => () => {
    return state.placedOrder;
  },
  returnCompleteOrder: (state, getters, rootState, rootGetters) => () => {
    return state.completeOrder;
  },
};
